import { Header } from "./Header";
import { Root } from "./Root";

export const Drawer = {
    Header,
    Root
}